import _ from "lodash";
import { useCallback, useReducer } from "react";
import { ViewOptionStateEnum } from "../contextual-app-bar/ViewOptionStateEnum";


export enum AlarmSetpointTestDisableTabEnum {
    None = -1,
    Devices = 0,
    Wells = 1,
    TankBatteries = 2,
    Tanks = 3
}

export type AlarmSetpointTestDisableStateType = {
    activeTab: AlarmSetpointTestDisableTabEnum;
    filterText: string;
    viewOptionState: ViewOptionStateEnum
};

enum AlarmSetpointTestDisableActionType {
    ActiveTabChanged = "ACTIVE_TAB_CHANGED",
    FilterChanged = "FILTER_CHANGED",
    ResetChanged = "RESET_CHANGED",
}

type AlarmSetpointTestDisableAction = {
    type: AlarmSetpointTestDisableActionType.ActiveTabChanged;
    activeTab: AlarmSetpointTestDisableTabEnum;
} | {
     type: AlarmSetpointTestDisableActionType.FilterChanged;
     payload: string;
} | {
    type: AlarmSetpointTestDisableActionType.ResetChanged;
    payload: void;
};

const initialState: AlarmSetpointTestDisableStateType = {
    activeTab: AlarmSetpointTestDisableTabEnum.None,
    filterText: '',
    viewOptionState: ViewOptionStateEnum.Default
};

const optionsChanged = (newState: AlarmSetpointTestDisableStateType, 
    defaultState: AlarmSetpointTestDisableStateType) => 
    newState.filterText !== defaultState.filterText;

function setpointTestDisableReducer(state: AlarmSetpointTestDisableStateType, action: AlarmSetpointTestDisableAction): AlarmSetpointTestDisableStateType {
    let copy = _.cloneDeep(state);    

    switch (action.type) {

        case AlarmSetpointTestDisableActionType.ActiveTabChanged:
            copy.activeTab = action.activeTab;
            break;

        case AlarmSetpointTestDisableActionType.FilterChanged:
            copy.filterText = action.payload;
            copy.viewOptionState = optionsChanged(copy, initialState) ? ViewOptionStateEnum.Changed : ViewOptionStateEnum.Default;
            break;

        case AlarmSetpointTestDisableActionType.ResetChanged:
            copy = _.cloneDeep(initialState);
            break;

        default:
            return state;
    }

    copy.viewOptionState = optionsChanged(copy, initialState) ? 
                            ViewOptionStateEnum.Changed : 
                            ViewOptionStateEnum.Default;

    return copy;
}

export type UseAlarmSetpointTestDisableStateType = {
    state: AlarmSetpointTestDisableStateType;
    setActiveTab: (activeTab: AlarmSetpointTestDisableTabEnum) => void;
    setFilterText: (value: string) => void;
    resetState: () => void;
};

export function useAlarmSetpointTestDisableState(): UseAlarmSetpointTestDisableStateType {

    const [state, dispatch] = useReducer(setpointTestDisableReducer, initialState);

    const setActiveTab = useCallback((activeTab: AlarmSetpointTestDisableTabEnum) => dispatch({
        type: AlarmSetpointTestDisableActionType.ActiveTabChanged,
        activeTab: activeTab
    }), []);

    const setFilterText = useCallback((value: string) => dispatch({
        type: AlarmSetpointTestDisableActionType.FilterChanged,
        payload: value
    }), []);


    const resetState = useCallback(() => dispatch({
        type: AlarmSetpointTestDisableActionType.ResetChanged,
        payload: undefined
    }), [])

    return {
        state,
        setActiveTab,
        setFilterText,
        resetState
    };
}
